import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import productApi from "../../../apis/Product.api";
import promotionApi from "../../../apis/Promotion.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const { Text } = Typography;

const CouponCreateComponent = ({ match }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [editCoupon, setEditCoupon] = useState({});
  const [formValues, setFormValues] = useState({
    coupon_score_type: 0,
  });
  const [couponTitleCnt, setCouponTitleCnt] = useState(0);
  const [couponBodyCnt, setCouponBodyCnt] = useState(0);
  const [codeValid, setCodeValid] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({
    benefit_type: 0, // 쿠폰 유형
    benefit_kind: "event", // 쿠폰 종류
    issuance_type: true, // 발급 유형
    date_type: "1week", // 다운로드 기간 > 날짜 유형 선택
    expiration_period: "period", // 유효 기간 설정 종류
    coupon_body: false, // 추가 설명 없음
    coupon_upsale_option: false, // 최소 구매 금액 설정
    discount_maximum_condition: false, // 할인 최대 금액
    quantity: false, // 수량 한정
    coupon_type: "total", // 쿠폰 적용 대상
  });
  const [exposureDate, setExposureDate] = useState({
    startDate: moment().startOf("day"),
    endDate: moment().add(1, "weeks").endOf("day"),
  });
  const [expirationDate, setExpirationDate] = useState({
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [searchOptions, setSearchOptions] = useState({
    product_name: "",
    product_brand_name: "",
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedProductRowKeys, setSelectedProductRowKeys] = useState([]);
  const [selectedProductRows, setSelectedProductRows] = useState([]);
  const [selectedRelatedProductRowKeys, setSelectedRelatedProductRowKeys] =
    useState([]);
  const [selectedRelatedProductRows, setSelectedRelatedProductRows] = useState(
    [],
  );
  const [productList, setProductList] = useState([]);
  const [relatedProductList, setRelatedProductList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedTargetList, setSelectedTargetList] = useState([]);
  const [error, setError] = useState("");

  const benefitTypeItems = [
    { label: "쿠폰", value: 0 },
    { label: "적립금", value: 1, disabled: true },
  ];
  const benefitKindItems = [
    { label: "이벤트", value: "event" },
    { label: "연관상품", value: "related_product", disabled: true },
    { label: "리뷰", value: "review", disabled: true },
    { label: "첫구매", value: "first_purchase", disabled: true },
    { label: "재구매", value: "repurchase", disabled: true },
    { label: "모든 회원", value: "all_member", disabled: true },
    { label: "생일", value: "birthday", disabled: true },
  ];
  const issuanceTypeItems = [
    { label: "자동", value: true },
    { label: "수동", value: false },
  ];
  const dateItems = [
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
    { label: "1년", value: "1year" },
    { label: "무제한", value: "unlimited" },
  ];
  const expirationPeriodItems = [
    { label: "기간으로 설정", value: "period" },
    { label: "발급일 기준으로 설정", value: "issue_date" },
    { label: "무제한", value: "unlimited" },
  ];
  const scoreTypeItems = [
    { scoreType: 0, scoreText: "%" },
    { scoreType: 1, scoreText: "원" },
  ];
  const couponTypeItems = [
    { label: "전체", value: "total" },
    { label: "브랜드", value: "brand" },
    { label: "상품", value: "product" },
  ];

  const disabledStartDate = (current) => {
    if (match.params.id) {
      return false;
    } else {
      return current.isBefore(moment());
    }
  };
  const disabledExposureEndDate = (current) => {
    if (match.params.id) {
      return false;
    } else {
      return current.isBefore(exposureDate.startDate);
    }
  };
  const disabledExpirationEndDate = (current) => {
    if (match.params.id) {
      return false;
    } else {
      return current.isBefore(exposureDate.startDate);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };
  const selectedRowSelection = {
    selectedRowKeys: selectedProductRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedProductRowKeys(selectedRowKeys);
      setSelectedProductRows(selectedRows);
    },
  };
  const selectedRelatedProductRowSelection = {
    selectedRowKeys: selectedRelatedProductRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRelatedProductRowKeys(selectedRowKeys);
      setSelectedRelatedProductRows(selectedRows);
    },
  };
  const productColumns = [
    {
      title: "상품번호",
      width: 80,
      dataIndex: "product_id",
      key: "product_id",
      fixed: "left",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: "브랜드명",
      // width: 120,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "상품 상태",
      // width: 100,
      dataIndex: "is_purchase",
      key: "is_purchase",
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>;
        } else if (value) {
          return <span>판매중</span>;
        } else {
          return <span>미판매</span>;
        }
      },
    },
    {
      title: "재고수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "판매가",
      // width: 90,
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "할인가",
      // width: 90,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ];
  const relatedMainProductColumns = [
    {
      title: "상품번호",
      width: 80,
      dataIndex: "main_product_id",
      key: "main_product_id",
      fixed: "left",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: "브랜드명",
      // width: 120,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "상품 상태",
      // width: 100,
      dataIndex: "is_purchase",
      key: "is_purchase",
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>;
        } else if (value) {
          return <span>판매중</span>;
        } else {
          return <span>미판매</span>;
        }
      },
    },
    {
      title: "재고수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "판매가",
      // width: 90,
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "할인가",
      // width: 90,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ];
  const relatedProductColumns = [
    {
      title: "연관상품번호",
      // width: 100,
      dataIndex: "related_product_id",
      key: "related_product_id",
      fixed: "left",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: "브랜드명",
      // width: 120,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "상품 상태",
      // width: 100,
      dataIndex: "is_purchase",
      key: "is_purchase",
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>;
        } else if (value) {
          return <span>판매중</span>;
        } else {
          return <span>미판매</span>;
        }
      },
    },
    {
      title: "재고수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "판매가",
      // width: 90,
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "할인가",
      // width: 90,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "주요상품번호",
      // width: 100,
      dataIndex: "main_product_id",
      key: "main_product_id",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ];
  const brandColumns = [
    {
      title: "브랜드명",
      // width: 90,
      dataIndex: "brand_name",
      key: "brand_name",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "회사명",
      // width: 90,
      dataIndex: "company_name",
      key: "company_name",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "대표자명",
      // width: 90,
      dataIndex: "representative",
      key: "representative",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
  ];
  const mainAndRelatedProductColumns = [
    {
      title: "연관상품번호",
      width: 100,
      dataIndex: "related_product_id",
      key: "related_product_id",
      fixed: "left",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    // {
    //     title: '카테고리',
    //     width: 120,
    //     dataIndex: 'product_category_name',
    //     key: 'product_category_name',
    //     ellipsis: true,
    //     render: (value) => {
    //         if (value === "") {
    //             return <span>-</span>
    //         } else {
    //             return value
    //         }
    //     }
    // },
    {
      title: "브랜드명",
      // width: 120,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      // width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "상품 상태",
      // width: 100,
      dataIndex: "is_purchase",
      key: "is_purchase",
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>;
        } else if (value) {
          return <span>판매중</span>;
        } else {
          return <span>미판매</span>;
        }
      },
    },
    {
      title: "재고수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "판매가",
      // width: 90,
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "할인가",
      // width: 90,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "주요상품번호",
      // width: 100,
      dataIndex: "main_product_id",
      key: "main_product_id",
      ellipsis: true,
      // sorter: (a, b) => {}
    },
    {
      title: "주요상품브랜드명",
      // width: 120,
      dataIndex: "main_product_brand_name",
      key: "main_product_brand_name",
      ellipsis: true,
    },
    {
      title: "주요상품명",
      // width: 150,
      dataIndex: "main_product_name",
      key: "main_product_name",
      ellipsis: true,
    },
  ];

  useEffect(() => {
    if (match.params.id) {
      getCouponInfo();
    } else {
      setEditCoupon({});
      setFormValues({ coupon_score_type: 0 });
      setCouponTitleCnt(0);
      setCouponBodyCnt(0);
      setCodeValid(0);
      setSelectedOptions({
        benefit_type: 0, // 쿠폰 유형
        benefit_kind: "event", // 쿠폰 종류
        issuance_type: true, // 발급 유형
        date_type: "1week", // 다운로드 기간 > 날짜 유형 선택
        expiration_period: "period", // 유효 기간 설정 종류
        coupon_body: false, // 추가 설명 없음
        coupon_upsale_option: false, // 최소 구매 금액 설정
        discount_maximum_condition: false, // 할인 최대 금액
        quantity: false, // 수량 한정
        coupon_type:
          user && user.role && user.role === "super_admin" ? "total" : "brand", // 쿠폰 적용 대상
      });
      setExposureDate({
        startDate: moment().startOf("day"),
        endDate: moment().add(1, "weeks").endOf("day"),
      });
      setExpirationDate({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
      });
      setSearchOptions({
        product_name: "",
        product_brand_name: "",
      });
      setSelectedRows([]);
      setSelectedRowKeys([]);
      setSelectedProductRows([]);
      setSelectedProductRowKeys([]);
      setSelectedRelatedProductRows([]);
      setSelectedRelatedProductRowKeys([]);
      setSelectedTargetList([]);
    }
  }, [match.params.id]);

  useEffect(() => {
    console.log("useEffect coupon_type 실행", selectedOptions);
    if (selectedOptions.coupon_type === "brand") {
      getBrandList();
    } else {
      getProductList();
    }
  }, [
    selectedOptions.benefit_kind,
    selectedOptions.coupon_type,
    selectedTargetList,
  ]);

  useEffect(() => {
    if (
      selectedOptions.benefit_kind === "related_product" &&
      selectedOptions.coupon_type === "product"
    ) {
      getRelatedProductList();
    }
  }, [selectedRows]);

  /**
   * coupon 수정 시, 기존 정보 가져오기
   */
  const getCouponInfo = async () => {
    setIsLoading(true);
    try {
      const res = await promotionApi.readCouponById(match.params.id);
      if (res.code === 200) {
        console.log("getCouponInfo success === ", res.result);
        // setEditCoupon(res.result)
        let resultBrandList = [];
        let resultProductList = [];
        if (res.result.coupon.coupon_type === "brand") {
          resultBrandList = await getBrandList("initial");
        } else if (
          res.result.coupon.coupon_type === "product" ||
          res.result.coupon.coupon_type === "related_product"
        ) {
          resultProductList = await getProductList("initial");
        }
        setFormValueFromEdit(res.result, resultBrandList, resultProductList);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("couponInfo read error", error);
    }
  };

  /**
   * 상품 List 가져오기
   */
  const getProductList = async (type = "", idList = []) => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          product_name: "",
          product_brand_name: "",
          target_type:
            selectedOptions.benefit_kind === "related_product" ? 0 : 1,
          idList:
            selectedOptions.benefit_kind === "related_product"
              ? selectedTargetList.map((target) => target.main_product_id)
              : selectedTargetList.map((target) => target.product_id),
        };
      } else if (type === "edit_item") {
        param = {
          ...searchOptions,
          target_type:
            selectedOptions.benefit_kind === "related_product" ? 0 : 1,
          idList: idList,
        };
      } else {
        param = {
          ...searchOptions,
          target_type:
            selectedOptions.benefit_kind === "related_product" ? 0 : 1,
          idList:
            selectedOptions.benefit_kind === "related_product"
              ? selectedTargetList.map((target) => target.main_product_id)
              : selectedTargetList.map((target) => target.product_id),
        };
      }
      param["created_by"] = user.id === 724 ? 1 : user.id;
      const res = await productApi.readProductListNotIncluded(param);
      if (res.code === 200) {
        setProductList(res.result);
        setIsLoading(false);
        return res.result;
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getProductList read error", error);
    }
  };

  /**
   * 연관 상품 List 가져오기
   */
  const getRelatedProductList = async () => {
    setIsLoading(true);
    try {
      let param;
      let mainProductIdList = [];
      let relatedProductIdList = [];
      for (const target of selectedTargetList) {
        mainProductIdList.push(target.main_product_id);
        relatedProductIdList.push(target.related_product_id);
      }
      if (selectedRows?.length === 0) {
        param = {
          main_product_id: 0,
          coupon_id: match.params.hasOwnProperty("id")
            ? editCoupon.coupon_id
            : null,
          relatedProductIdList: relatedProductIdList,
          mainProductIdList: mainProductIdList,
        };
      } else {
        param = {
          main_product_id: selectedRows.find(
            (row) => row.id === selectedRowKeys[0],
          ).main_product_id,
          coupon_id: match.params.hasOwnProperty("id")
            ? editCoupon.coupon_id
            : null,
          relatedProductIdList: relatedProductIdList,
          mainProductIdList: mainProductIdList,
        };
      }
      const res = await productApi.readRelatedProductListWithoutIdList(param);
      if (res.code === 200) {
        setRelatedProductList(res.result);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getRelatedProductList read error", error);
    }
  };

  /**
   * brand List 가져오기
   */
  const getBrandList = async (type = "", idList = []) => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          product_brand_name: "",
          idList: selectedTargetList.map((target) => target.id),
        };
      } else if (type === "edit_item") {
        param = {
          product_brand_name: searchOptions.product_brand_name,
          idList: idList,
        };
      } else {
        param = {
          product_brand_name: searchOptions.product_brand_name,
          idList: selectedTargetList.map((target) => target.id),
        };
      }
      param["created_by"] = user.id === 724 ? 1 : user.id;
      const res = await productApi.readBrandListNotIncluded(param);
      if (res.code === 200) {
        setBrandList(res.result);
        setIsLoading(false);
        return res.result;
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getBrandList read error", error);
    }
  };

  /**
   * Coupon code valid
   */
  const codeValidation = async (code) => {
    setIsLoading(true);
    try {
      const res = await promotionApi.couponCodeValidation(code);
      if (res.code === 200) {
        if (res.result) {
          setCodeValid(2);
        } else {
          setCodeValid(1);
        }
      } else {
        setCodeValid(1);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("codeValidation valid error", error);
    }
  };

  /**
   * 수정할 coupon 정보 form에 setting
   */
  const setFormValueFromEdit = (
    couponInfo,
    resultBrandList,
    resultProductList,
  ) => {
    let editCouponInfo = {};
    let settingFormValue = {};
    let settingSelectedOption = {};
    let editList = [];
    let settingSelectedTargetList = [];
    for (const key in couponInfo.coupon) {
      if (key === "coupon_body") {
        // 추가설명
        if (couponInfo.coupon[key] === null || couponInfo.coupon[key] === "") {
          settingSelectedOption[key] = true;
          setCouponBodyCnt(0);
        } else {
          settingSelectedOption[key] = false;
          setCouponBodyCnt(couponInfo.coupon[key]?.length);
        }
        settingFormValue[key] = couponInfo.coupon[key];
      } else if (key === "coupon_expiration_To") {
        // 사용 가능 기간설정
        if (
          couponInfo.coupon[key] === null &&
          couponInfo.coupon["coupon_period_date"] === null
        ) {
          settingSelectedOption["expiration_period"] = "unlimited";
        } else if (couponInfo.coupon[key] !== null) {
          settingSelectedOption["expiration_period"] = "period";
          setExpirationDate({
            ...expirationDate,
            startDate: moment(couponInfo.coupon["coupon_from"]),
            endDate: moment(couponInfo.coupon[key]),
          });
        } else if (couponInfo.coupon["coupon_period_date"] !== null) {
          settingSelectedOption["expiration_period"] = "issue_date";
          settingFormValue["coupon_period_date"] =
            couponInfo.coupon["coupon_period_date"];
        }
      } else if (key === "coupon_to") {
        // 다운로드 기간
        const startDate = moment(couponInfo.coupon["coupon_from"]);
        const endDate = moment(couponInfo.coupon[key]);
        let diffDays = endDate.diff(startDate, "days");
        if (diffDays === 7) {
          settingSelectedOption["date_type"] = "1week";
        } else {
          if (
            moment(couponInfo.coupon["coupon_from"])
              .add(1, "months")
              .isSame(endDate, "day")
          ) {
            settingSelectedOption["date_type"] = "1month";
          } else if (
            moment(couponInfo.coupon["coupon_from"])
              .add(3, "months")
              .isSame(endDate, "day")
          ) {
            settingSelectedOption["date_type"] = "3month";
          } else if (
            moment(couponInfo.coupon["coupon_from"])
              .add(6, "months")
              .isSame(endDate, "day")
          ) {
            settingSelectedOption["date_type"] = "6month";
          } else if (
            moment(couponInfo.coupon["coupon_from"])
              .add(1, "years")
              .isSame(endDate, "day")
          ) {
            settingSelectedOption["date_type"] = "1year";
          } else {
            settingSelectedOption["date_type"] = "";
          }
        }
        setExposureDate({
          ...exposureDate,
          startDate: moment(couponInfo.coupon["coupon_from"]),
          endDate: moment(couponInfo.coupon[key]),
        });
      } else if (key === "coupon_influencer_yn") {
        // 발급유형
        if (couponInfo.coupon[key]) {
          settingFormValue["coupon_abbreviation"] =
            couponInfo.coupon["coupon_abbreviation"];
          setCodeValid(2);
        }
        settingSelectedOption["issuance_type"] = !couponInfo.coupon[key];
      } else if (key === "coupon_maximum_score") {
        // 할인 최대 금액
        if (couponInfo.coupon[key] === null) {
          settingSelectedOption["discount_maximum_condition"] = true;
        } else {
          settingSelectedOption["discount_maximum_condition"] = false;
          settingFormValue[key] = couponInfo.coupon[key];
        }
      } else if (key === "coupon_publish_number") {
        // 수량 한정
        if (couponInfo.coupon[key] === 9999999) {
          settingSelectedOption["quantity"] = true;
        } else {
          settingSelectedOption["quantity"] = false;
          settingFormValue[key] = couponInfo.coupon[key];
        }
      } else if (key === "coupon_title") {
        settingFormValue[key] = couponInfo.coupon[key];
        setCouponTitleCnt(couponInfo.coupon[key]?.length);
      } else if (key === "coupon_type") {
        // 쿠폰 종류 및 쿠폰 적용 대상
        switch (couponInfo.coupon[key]) {
          case "event_all":
          case "event":
            settingSelectedOption["benefit_kind"] = "event";
            settingSelectedOption[key] = "total";
            break;
          case "category":
            settingSelectedOption["benefit_kind"] = "event";
            settingSelectedOption[key] = couponInfo.coupon[key];
            break;
          case "brand":
            settingSelectedOption["benefit_kind"] = "event";
            settingSelectedOption[key] = couponInfo.coupon[key];
            editList = resultBrandList.filter((brand) => {
              if (couponInfo.relatedIdList.includes(brand.id)) {
                settingSelectedTargetList.push(brand);
              } else {
                return brand;
              }
            });
            setBrandList(editList);
            break;
          case "product":
            settingSelectedOption["benefit_kind"] = "event";
            settingSelectedOption[key] = couponInfo.coupon[key];
            editList = resultProductList.filter((product) => {
              if (couponInfo.relatedIdList.includes(product.product_id)) {
                settingSelectedTargetList.push(product);
              } else {
                return product;
              }
            });
            setProductList(editList);
            break;
          case "related_product":
            settingSelectedOption["benefit_kind"] = "related_product";
            settingSelectedOption[key] = "product";
            settingSelectedTargetList = couponInfo.relatedProductList;
            break;
        }
      } else if (key === "coupon_upsale_option") {
        // 최소 구매 금액 설정
        if (couponInfo.coupon[key] === null) {
          settingSelectedOption[key] = true;
        } else {
          settingSelectedOption[key] = false;
          settingFormValue[key] = couponInfo.coupon[key];
        }
      } else if (key === "coupon_score" || key === "coupon_score_type") {
        // formValue에만 저장
        settingFormValue[key] = couponInfo.coupon[key];
      } else if (
        key === "coupon_id" ||
        key === "id" ||
        key === "coupon_available_number" ||
        key === "coupon_is_available" ||
        key === "coupon_publish_available" ||
        key === "coupon_usage_number" ||
        key === "created_at" ||
        key === "created_by"
      ) {
        // editCouponInfo에 저장
        editCouponInfo[key] = couponInfo.coupon[key];
      }
    }
    setSelectedOptions({ ...selectedOptions, ...settingSelectedOption });
    setFormValues({ ...formValues, ...settingFormValue });
    setEditCoupon(editCouponInfo);
    setSelectedTargetList(settingSelectedTargetList);
  };

  /**
   * radio select options handleChange
   */
  const handleSelectOptions = (e) => {
    const { name, value } = e.target;
    if (name === "coupon_type") {
      setSearchOptions({
        product_name: "",
        product_brand_name: "",
      });
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setSelectedProductRowKeys([]);
      setSelectedProductRows([]);
      setSelectedOptions({ ...selectedOptions, [name]: value });
      setSelectedTargetList([]);
      setFormValues({ ...formValues, [name]: value });
    } else if (name === "benefit_kind") {
      if (value === "related_product") {
        setSelectedOptions({
          ...selectedOptions,
          [name]: value,
          coupon_type: "product",
        });
      } else {
        setSelectedOptions({ ...selectedOptions, [name]: value });
      }
    } else if (name === "date_type") {
      const startDate = exposureDate.startDate.format("YYYY-MM-DD");
      if (value === "1week") {
        setExposureDate({
          ...exposureDate,
          endDate: moment(startDate).add(1, "weeks").endOf("day"),
        });
      } else if (value === "1month") {
        setExposureDate({
          ...exposureDate,
          endDate: moment(startDate).add(1, "months").endOf("day"),
        });
      } else if (value === "3month") {
        setExposureDate({
          ...exposureDate,
          endDate: moment(startDate).add(3, "months").endOf("day"),
        });
      } else if (value === "6month") {
        setExposureDate({
          ...exposureDate,
          endDate: moment(startDate).add(6, "months").endOf("day"),
        });
      } else if (value === "1year") {
        setExposureDate({
          ...exposureDate,
          endDate: moment(startDate).add(1, "years").endOf("day"),
        });
      } else if (value === "unlimited") {
        setExposureDate({ ...exposureDate, endDate: null });
      }
      setSelectedOptions({ ...selectedOptions, [name]: value });
    } else if (name === "expiration_period") {
      switch (value) {
        case "period":
          setExpirationDate({
            ...expirationDate,
            startDate: exposureDate.startDate,
            endDate: exposureDate.endDate,
          });
          setFormValues({ ...formValues, coupon_period_date: null });
          break;
        case "issue_date":
          setFormValues({ ...formValues, coupon_expiration_To: null });
          break;
        case "unlimited":
          setFormValues({
            ...formValues,
            coupon_period_date: null,
            coupon_expiration_To: null,
          });
          break;
      }
      setSelectedOptions({ ...selectedOptions, [name]: value });
    } else if (name === "issuance_type") {
      if (value) {
        setCodeValid(0);
        setFormValues({ ...formValues, coupon_abbreviation: null });
      }
      setSelectedOptions({ ...selectedOptions, [name]: value });
    } else if (name === "coupon_body") {
      if (e.target.checked) {
        setFormValues({ ...formValues, [name]: null });
        setCouponBodyCnt(0);
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked });
    } else if (name === "coupon_upsale_option") {
      if (e.target.checked) {
        setFormValues({ ...formValues, [name]: null });
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked });
    } else if (name === "discount_maximum_condition") {
      if (e.target.checked) {
        setFormValues({ ...formValues, coupon_maximum_score: null });
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked });
    } else if (name === "quantity") {
      if (e.target.checked) {
        setFormValues({ ...formValues, coupon_publish_number: null });
      }
      setSelectedOptions({ ...selectedOptions, [name]: e.target.checked });
    } else {
      setSelectedOptions({ ...selectedOptions, [name]: value });
    }
  };

  /**
   * 검색어 입력
   */
  const onSearchProduct = () => {
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setSelectedProductRows([]);
    setSelectedProductRowKeys([]);
    if (selectedOptions.coupon_type === "brand") {
      getBrandList();
    } else {
      getProductList();
    }
  };

  /**
   * 초기화
   */
  const handleResetSearch = () => {
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setSelectedProductRows([]);
    setSelectedProductRowKeys([]);
    setSearchOptions({
      product_name: "",
      product_brand_name: "",
    });
    if (selectedOptions.coupon_type === "brand") {
      getBrandList("initial");
    } else {
      getProductList("initial");
    }
  };

  /**
   * 선택 항목 등록
   */
  const handleSelectedRowRegister = () => {
    if (selectedOptions.benefit_kind === "related_product") {
      const newSelectedList = [
        ...selectedTargetList,
        ...selectedRelatedProductRows,
      ];
      setSelectedTargetList(newSelectedList);
      setSelectedRelatedProductRows([]);
      setSelectedRelatedProductRowKeys([]);
      setSelectedProductRows([]);
      setSelectedProductRowKeys([]);
      setSelectedRows([]);
      setSelectedRowKeys([]);
    } else {
      const newSelectedList = [...selectedTargetList, ...selectedRows];
      setSelectedTargetList(newSelectedList);
      setSelectedRows([]);
      setSelectedRowKeys([]);
      if (selectedOptions.coupon_type === "brand") {
        getBrandList(
          "edit_item",
          newSelectedList.map((selectedItem) => selectedItem.id),
        );
      } else {
        getProductList(
          "edit_item",
          newSelectedList.map((selectedItem) => selectedItem.product_id),
        );
      }
    }
  };

  /**
   * 선택 항목 취소
   */
  const handleSelectedRowCancel = () => {
    if (selectedOptions.benefit_kind === "related_product") {
      const exceptedTargetList = selectedTargetList.filter(
        (target) => !selectedProductRowKeys.includes(target.id),
      );
      setSelectedTargetList(exceptedTargetList);
      setSelectedProductRows([]);
      setSelectedProductRowKeys([]);
      getProductList("edit_item", []);
    } else {
      let exceptedTargetList = [];
      if (selectedOptions.coupon_type === "brand") {
        exceptedTargetList = selectedTargetList.filter(
          (target) => !selectedProductRowKeys.includes(target.id),
        );
      } else {
        exceptedTargetList = selectedTargetList.filter(
          (target) => !selectedProductRowKeys.includes(target.product_id),
        );
      }
      setSelectedTargetList(exceptedTargetList);
      setSelectedProductRows([]);
      setSelectedProductRowKeys([]);
      if (selectedOptions.coupon_type === "brand") {
        getBrandList(
          "edit_item",
          exceptedTargetList.map((selectedItem) => selectedItem.id),
        );
      } else {
        getProductList(
          "edit_item",
          exceptedTargetList.map((selectedItem) => selectedItem.product_id),
        );
      }
    }
  };

  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        if (selectedOptions.benefit_kind === "related_product") {
          if (selectedRowKeys.includes(record.id)) {
            setSelectedRowKeys([]);
            setSelectedRows([]);
          } else {
            setSelectedRowKeys([record.id]);
            setSelectedRows([record]);
          }
        } else {
          if (selectedOptions.coupon_type === "brand") {
            if (selectedRowKeys.includes(record.id)) {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.id),
              );
              setSelectedRows(
                selectedRows.filter((row) => row.id !== record.id),
              );
            } else {
              setSelectedRowKeys([...selectedRowKeys, record.id]);
              setSelectedRows([...selectedRows, record]);
            }
          } else {
            if (selectedRowKeys.includes(record.product_id)) {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.product_id),
              );
              setSelectedRows(
                selectedRows.filter(
                  (row) => row.product_id !== record.product_id,
                ),
              );
            } else {
              setSelectedRowKeys([...selectedRowKeys, record.product_id]);
              setSelectedRows([...selectedRows, record]);
            }
          }
        }
      },
    };
  };

  const handleProductRowEvent = (record) => {
    return {
      onClick: (_) => {
        if (selectedOptions.benefit_kind === "related_product") {
          if (selectedProductRowKeys.includes(record.id)) {
            setSelectedProductRowKeys(
              selectedProductRowKeys.filter((key) => key !== record.id),
            );
            setSelectedProductRows(
              selectedProductRows.filter((row) => row.id !== record.id),
            );
          } else {
            setSelectedProductRowKeys([...selectedProductRowKeys, record.id]);
            setSelectedProductRows([...selectedProductRows, record]);
          }
        } else {
          if (selectedOptions.coupon_type === "brand") {
            if (selectedProductRowKeys.includes(record.id)) {
              setSelectedProductRowKeys(
                selectedProductRowKeys.filter((key) => key !== record.id),
              );
              setSelectedProductRows(
                selectedProductRows.filter((row) => row.id !== record.id),
              );
            } else {
              setSelectedProductRowKeys([...selectedProductRowKeys, record.id]);
              setSelectedProductRows([...selectedProductRows, record]);
            }
          } else {
            if (selectedProductRowKeys.includes(record.product_id)) {
              setSelectedProductRowKeys(
                selectedProductRowKeys.filter(
                  (key) => key !== record.product_id,
                ),
              );
              setSelectedProductRows(
                selectedProductRows.filter(
                  (row) => row.product_id !== record.product_id,
                ),
              );
            } else {
              setSelectedProductRowKeys([
                ...selectedProductRowKeys,
                record.product_id,
              ]);
              setSelectedProductRows([...selectedProductRows, record]);
            }
          }
        }
      },
    };
  };

  const handleRelatedProductRowEvent = (record) => {
    return {
      onClick: (_) => {
        if (selectedRelatedProductRowKeys.includes(record.related_product_id)) {
          setSelectedRelatedProductRowKeys(
            selectedRelatedProductRowKeys.filter(
              (key) => key !== record.related_product_id,
            ),
          );
          setSelectedRelatedProductRows(
            selectedRelatedProductRows.filter(
              (row) => row.related_product_id !== record.related_product_id,
            ),
          );
        } else {
          setSelectedRelatedProductRowKeys([
            ...selectedRelatedProductRowKeys,
            record.related_product_id,
          ]);
          setSelectedRelatedProductRows([
            ...selectedRelatedProductRows,
            record,
          ]);
        }
      },
    };
  };

  /**
   * input value change handler
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "coupon_title") {
      setFormValues({ ...formValues, [name]: value });
      setCouponTitleCnt(value?.length);
    } else if (name === "coupon_body") {
      setFormValues({ ...formValues, [name]: value });
      setCouponBodyCnt(value?.length);
    } else if (name === "coupon_abbreviation") {
      if (value?.length === 0) {
        setCodeValid(0);
      } else {
        codeValidation(value);
      }
      setFormValues({ ...formValues, [name]: value });
    } else if (name === "product_name" || name === "product_brand_name") {
      setSearchOptions({ ...searchOptions, [name]: value });
    } else if (name === "coupon_score") {
      if (formValues?.coupon_score_type === 0) {
        let scoreValue = value;
        if (scoreValue > 100) {
          setFormValues({ ...formValues, [name]: 100 });
        } else {
          setFormValues({ ...formValues, [name]: scoreValue });
        }
      } else {
        setFormValues({ ...formValues, [name]: value });
      }
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  useEffect(() => {
    if (formValues?.coupon_score_type === 0) {
      let scoreValue = formValues?.coupon_score;
      if (scoreValue > 100) {
        setFormValues({ ...formValues, coupon_score: 100 });
      }
    }
  }, [formValues]);

  const handleCancel = () => {
    if (
      window.confirm("작성 중이던 내용이 있습니다. 그래도 취소하시겠습니까?")
    ) {
      history.push(`/promotion/coupon/view`);
    }
  };

  const handleFinish = async () => {
    setIsLoading(true);
    try {
      const result = formValuesValidation();
      if (result) {
        // if (selectedOptions.benefit_kind === "related_product" && selectedOptions.coupon_type === "product") {
        //     const relatedProductParam = {
        //         coupon_id: match.params.hasOwnProperty("id") ? editCoupon.coupon_id : null,
        //         relatedProductIdList: selectedTargetList.map((target) => target.related_product_id)
        //     }
        //     const relatedProductRes = await productApi.readRelatedProductListAppliedCoupon(relatedProductParam)
        //     if (relatedProductRes.code === 200) {
        //         if (relatedProductRes.result?.length !== 0) {
        //             let relatedProductNameList = []
        //             for (const product of relatedProductRes.result) {
        //                 if (!relatedProductNameList.includes(product.product_name)) {
        //                     relatedProductNameList.push(product.product_name)
        //                 }
        //             }
        //             console.log("relatedProductNameList", relatedProductNameList, relatedProductNameList.join(", "))
        //             if (!window.confirm(`${relatedProductNameList.join(", ")}에는 이미 쿠폰이 적용되어있습니다. 현재 등록한 연관상품에 해당 쿠폰으로 변경하시겠습니까?`)) {
        //                 throw `${relatedProductNameList.join(", ")}에 이미 쿠폰이 적용되어있습니다.`
        //             }
        //         }
        //     } else {
        //         throw `해당 연관상품에 대한 쿠폰 ${match.params.hasOwnProperty("id") ? "수정" : "등록"}에 실패하였습니다. 관리자에게 문의해주시길 바랍니다.`
        //     }
        // }
        let res;
        let couponMasterDTO = {};
        let newEditCoupon = {
          ...formValues,
          coupon_from: exposureDate.startDate.startOf("day"),
          coupon_to: exposureDate.endDate,
        };
        for (const key in selectedOptions) {
          if (key === "issuance_type") {
            newEditCoupon["coupon_influencer_yn"] = !selectedOptions[key];
          } else if (key === "expiration_period") {
            if (selectedOptions[key] === "unlimited") {
              newEditCoupon["coupon_expiration_To"] = null;
              newEditCoupon["coupon_period_date"] = null;
            } else if (selectedOptions[key] === "period") {
              newEditCoupon["coupon_expiration_To"] = expirationDate.endDate;
            }
          } else if (key === "quantity") {
            if (selectedOptions[key]) {
              newEditCoupon["coupon_publish_number"] = 9999999;
            }
          } else if (key === "coupon_type") {
            if (
              selectedOptions.benefit_kind === "event" &&
              selectedOptions[key] === "total"
            ) {
              newEditCoupon[key] = "event_all";
            } else if (selectedOptions.benefit_kind === "related_product") {
              newEditCoupon[key] = selectedOptions.benefit_kind;
              couponMasterDTO["relatedIdList"] = selectedTargetList.map(
                (target) => target.related_product_id,
              );
              couponMasterDTO["relatedProductList"] = selectedTargetList;
            } else if (selectedOptions[key] === "category") {
              newEditCoupon[key] = selectedOptions[key];
              couponMasterDTO["relatedCategoryIdList"] = selectedTargetList.map(
                (target) => target.category_id,
              );
            } else if (selectedOptions[key] === "brand") {
              newEditCoupon[key] = selectedOptions[key];
              couponMasterDTO["relatedIdList"] = selectedTargetList.map(
                (target) => target.id,
              );
            } else if (selectedOptions[key] === "product") {
              newEditCoupon[key] = selectedOptions[key];
              couponMasterDTO["relatedIdList"] = selectedTargetList.map(
                (target) => target.product_id,
              );
            } else {
              newEditCoupon[key] = selectedOptions[key];
            }
          }
        }
        if (match.params.id) {
          couponMasterDTO["editKey"] = "all";
          // couponMasterDTO["editor"] = user.user_id
          couponMasterDTO["created_by"] = user.id === 724 ? 1 : user.id;
          couponMasterDTO["coupon"] = { ...newEditCoupon, ...editCoupon };
          res = await promotionApi.editCoupon(couponMasterDTO);
        } else {
          newEditCoupon["coupon_is_available"] = true;
          newEditCoupon["coupon_publish_available"] = true;
          newEditCoupon["coupon_available_number"] = 1;
          newEditCoupon["created_at"] = user.id === 724 ? 1 : user.id;
          couponMasterDTO["coupon"] = newEditCoupon;
          couponMasterDTO["created_by"] = user.id === 724 ? 1 : user.id;
          res = await promotionApi.createCoupon(couponMasterDTO);
        }
        if (res.code === 200) {
          alert("해당 내용이 성공적으로 반영되었습니다.");
          history.push(`/promotion/coupon/view`);
        } else if (res.code === 999) {
          alert(res.msg);
        } else {
          alert(
            `쿠폰을 ${
              match.params.hasOwnProperty("id") ? "수정" : "등록"
            }하는데 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.`,
          );
        }
        setIsLoading(false);
      } else {
        throw "not valid";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleFinish coupon register error", error);
    }
  };

  const formValuesValidation = () => {
    try {
      for (const key in selectedOptions) {
        switch (key) {
          case "issuance_type":
            if (!selectedOptions.issuance_type) {
              if (
                !formValues.hasOwnProperty("coupon_abbreviation") ||
                formValues.coupon_abbreviation === null ||
                codeValid !== 2
              ) {
                throw `발급 유형을 [수동]으로 선택하셨습니다. 코드 값을 입력하지 않으셨거나 이미 존재하는 코드 값입니다.`;
              }
            }
            break;
          case "expiration_period":
            // if (selectedOptions[key] === "period") {
            //     if (!formValues.hasOwnProperty("coupon_expiration_To") || formValues.coupon_expiration_To ===  null) {
            //         throw `사용 가능 기간의 종료일을 선택하지 않았습니다.\n종료일을 선택하거나 무제한을 선택해주시길 바랍니다.`
            //     }
            // } else
            if (selectedOptions[key] === "issue_date") {
              if (
                !formValues.hasOwnProperty("coupon_period_date") ||
                formValues.coupon_period_date === null
              ) {
                throw `사용 가능 기간을 발급일 기준으로 선택하셨습니다. 유효일수를 입력하거나 무제한을 선택해주시길 바랍니다.`;
              }
            }
            break;
          case "coupon_body":
            if (!selectedOptions[key]) {
              if (
                !formValues.hasOwnProperty(key) ||
                formValues[key] === null ||
                formValues[key]?.length === 0
              ) {
                throw `추가 설명 입력란이 비어있습니다. 적을 내용이 없다면 '없음'으로 체크해주시길 바랍니다.`;
              }
            }
            break;
          case "coupon_upsale_option":
            if (!selectedOptions[key]) {
              if (
                !formValues.hasOwnProperty(key) ||
                formValues[key] === null ||
                formValues[key] === 0
              ) {
                throw `최소 구매 금액 설정의 입력란이 비어있습니다. 적을 내용이 없다면 '조건 없음'으로 체크해주시길 바랍니다.`;
              }
            }
            break;
          case "discount_maximum_condition":
            if (!selectedOptions[key]) {
              if (
                !formValues.hasOwnProperty("coupon_maximum_score") ||
                formValues["coupon_maximum_score"] === null ||
                formValues["coupon_maximum_score"] === 0
              ) {
                throw `할인 최대 금액의 입력란이 비어있습니다. 적을 내용이 없다면 '무제한'으로 체크해주시길 바랍니다.`;
              }
            }
            break;
          case "quantity":
            if (!selectedOptions[key]) {
              if (
                !formValues.hasOwnProperty("coupon_publish_number") ||
                formValues["coupon_publish_number"] === null ||
                formValues["coupon_publish_number"] === 0
              ) {
                throw `수량 한정의 입력란이 비어있습니다. 적을 내용이 없다면 '무제한'으로 체크해주시길 바랍니다.`;
              }
            }
            break;
        }
      }
      if (formValues.coupon_title === null || formValues.coupon_title === "") {
        throw `쿠폰명을 입력하지 않았습니다.`;
      } else if (
        formValues.coupon_score === null ||
        formValues.coupon_score === 0
      ) {
        throw `할인설정 항목에 값이 비어있습니다.`;
      } else if (
        selectedOptions.coupon_type !== "total" &&
        selectedTargetList?.length === 0
      ) {
        throw `쿠폰을 적용할 대상이 없습니다.`;
      }
      return true;
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("formValuesValidation validation error", error);
      alert(error);
      return false;
    }
  };

  const [exampleShow, setExampleShow] = useState(false);
  const [exampleTitle, setExampleTitle] = useState({
    id: "",
    title: "",
  });

  return (
    <>
      {/* 예시 모달 */}
      <Modal
        className="related-product-modal-wrap"
        width={"40%"}
        title={exampleTitle.title}
        visible={exampleShow}
        // maskClosable={false}
        onCancel={() => setExampleShow(!exampleShow)}
        footer={null}
      >
        <img
          alt={exampleTitle.title}
          src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}.png`}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </Modal>
      <ContentHeaderComponent
        title={`쿠폰 ${match.params.hasOwnProperty("id") ? "수정" : "등록"}`}
      />
      <div className="coupon-register-wrap">
        <Row
          align={"middle"}
          wrap={false}
          style={{
            borderBottom: "solid 1px #ced4da",
            paddingBottom: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          <span style={{ fontSize: "1.3em" }}>쿠폰 등록</span>
          <span
            className="product-register-box-subtitle"
            style={{
              fontSize: "0.9rem",
              cursor: "pointer",
              marginLeft: "10px",
              color: "#117ffa",
              borderBottom: "solid 1px #117ffa",
            }}
            id={"tag"}
            onClick={() => {
              setExampleShow(true);
              setExampleTitle({
                id: "coupon",
                title: "쿠폰 예시",
              });
            }}
          >
            예시
          </span>
        </Row>
        <Form.Item
          className="center-label"
          label="쿠폰 유형"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            name="benefit_type"
            options={benefitTypeItems}
            onChange={handleSelectOptions}
            value={selectedOptions.benefit_type}
            disabled={match.params.hasOwnProperty("id")}
          />
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="쿠폰 종류"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            name="benefit_kind"
            options={benefitKindItems}
            onChange={handleSelectOptions}
            value={selectedOptions.benefit_kind}
            disabled={match.params.hasOwnProperty("id")}
          />
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="발급 유형"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Radio.Group
              name="issuance_type"
              options={issuanceTypeItems}
              onChange={handleSelectOptions}
              value={selectedOptions.issuance_type}
              disabled={match.params.hasOwnProperty("id")}
            />
            <Input
              name="coupon_abbreviation"
              placeholder="코드 값 입력"
              value={formValues.coupon_abbreviation}
              onChange={handleInputChange}
              disabled={
                selectedOptions.issuance_type ||
                match.params.hasOwnProperty("id")
              }
              style={{ width: 200 }}
            />
            {codeValid === 1 && (
              <Text type="danger" style={{ marginLeft: 8, fontSize: 12 }}>
                이미 존재하는 코드입니다.
              </Text>
            )}
            {codeValid === 2 && (
              <Text type="success" style={{ marginLeft: 8, fontSize: 12 }}>
                사용할 수 있는 코드입니다.
              </Text>
            )}
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="쿠폰명"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className="text-input-wrap"
              name="coupon_title"
              placeholder="쿠폰명을 입력해주세요."
              maxLength={18}
              value={formValues.coupon_title}
              onChange={handleInputChange}
              required
            />
            <div className="count-text">{couponTitleCnt}/18</div>
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          label="다운로드 기간"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            className="date-type-select-wrap options-list"
            name="date_type"
            options={dateItems}
            onChange={handleSelectOptions}
            value={selectedOptions.date_type}
            optionType="button"
          />
          <Row align="middle">
            <DatePicker
              className="date-input-wrap"
              format="YYYY-MM-DD"
              value={exposureDate.startDate}
              disabledDate={disabledStartDate}
              allowClear={false}
              onChange={(value) => {
                console.log(
                  "다운로드 기간",
                  value.startOf("day").format("YYYY-MM-DD HH:mm"),
                );
                setSelectedOptions({ ...selectedOptions, date_type: "" });
                setExposureDate({
                  ...exposureDate,
                  startDate: value.startOf("day"),
                });
                setExpirationDate({
                  ...expirationDate,
                  startDate: value.startOf("day"),
                  endDate: value.endOf("day"),
                });
              }}
              onOk={() =>
                setSelectedOptions({ ...selectedOptions, date_type: "" })
              }
            />
            <div style={{ margin: "0 10px" }}>~</div>
            <DatePicker
              className="date-input-wrap"
              format="YYYY-MM-DD"
              value={exposureDate.endDate}
              disabledDate={disabledExposureEndDate}
              allowClear={false}
              onChange={(value) => {
                setSelectedOptions({ ...selectedOptions, date_type: "" });
                setExposureDate({ ...exposureDate, endDate: value });
                setExpirationDate({ ...expirationDate, endDate: value });
              }}
              onOk={() =>
                setSelectedOptions({ ...selectedOptions, date_type: "" })
              }
            />
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          label="사용 가능 기간"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Radio.Group
            className="date-type-select-wrap"
            name="expiration_period"
            options={expirationPeriodItems}
            onChange={handleSelectOptions}
            value={selectedOptions.expiration_period}
          />
          {selectedOptions.expiration_period === "period" && (
            <Row align="middle">
              <DatePicker
                className="date-input-wrap"
                format="YYYY-MM-DD"
                value={expirationDate.startDate}
                disabledDate={disabledStartDate}
                disabled
                onChange={(value) => {
                  setSelectedOptions({ ...selectedOptions, date_type: "" });
                  setExpirationDate({ ...expirationDate, startDate: value });
                }}
                onOk={() =>
                  setSelectedOptions({ ...selectedOptions, date_type: "" })
                }
              />
              <div style={{ margin: "0 10px" }}>~</div>
              <DatePicker
                className="date-input-wrap"
                format="YYYY-MM-DD"
                value={expirationDate.endDate}
                disabledDate={disabledExpirationEndDate}
                allowClear={false}
                onChange={(value) => {
                  setSelectedOptions({ ...selectedOptions, date_type: "" });
                  setExpirationDate({ ...expirationDate, endDate: value });
                }}
                onOk={() =>
                  setSelectedOptions({ ...selectedOptions, date_type: "" })
                }
              />
            </Row>
          )}

          {selectedOptions.expiration_period === "issue_date" && (
            <Row align="middle">
              <div
                className="subtext"
                style={{ marginLeft: 0, marginRight: 10 }}
              >
                발급일로부터
              </div>
              <Input
                name="coupon_period_date"
                value={formValues.coupon_period_date}
                onChange={handleInputChange}
                style={{ width: 150 }}
              />
              <div className="subtext">일 간 유효</div>
            </Row>
          )}
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="추가 설명"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              name="coupon_body"
              placeholder="설명을 입력해주세요"
              maxLength={20}
              disabled={selectedOptions.coupon_body}
              value={formValues.coupon_body}
              onChange={handleInputChange}
              style={{ width: 300 }}
            />
            <div className="count-text">{couponBodyCnt}/20</div>
            <Checkbox
              name="coupon_body"
              checked={selectedOptions.coupon_body}
              onChange={handleSelectOptions}
            >
              없음
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="최소 구매 금액 설정"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className="coupon-register-form-input-number"
              type="number"
              name="coupon_upsale_option"
              value={formValues.coupon_upsale_option}
              disabled={selectedOptions.coupon_upsale_option}
              min={0}
              addonAfter={<span>원</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: "right" }}
            />
            <div className="subtext">이상 구매 시</div>
            <Checkbox
              name="coupon_upsale_option"
              checked={selectedOptions.coupon_upsale_option}
              onChange={handleSelectOptions}
            >
              조건 없음
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="할인설정"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Input
            className="coupon-register-form-input-number"
            type="number"
            name="coupon_score"
            value={formValues.coupon_score}
            onChange={handleInputChange}
            min={0}
            required
            addonAfter={
              <Select
                style={{ textAlign: "left" }}
                value={formValues.coupon_score_type}
                onChange={(value) =>
                  setFormValues({ ...formValues, coupon_score_type: value })
                }
              >
                {scoreTypeItems.map((item, idx) => (
                  <Option key={`score_type_${idx}`} value={item.scoreType}>
                    {item.scoreText}
                  </Option>
                ))}
              </Select>
            }
            style={{ width: 170, textAlign: "right" }}
          />
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="할인 최대 금액"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <div className="subtext" style={{ marginLeft: 0, marginRight: 6 }}>
              최대
            </div>
            <Input
              className="coupon-register-form-input-number"
              type="number"
              name="coupon_maximum_score"
              value={formValues.coupon_maximum_score}
              disabled={selectedOptions.discount_maximum_condition}
              min={0}
              addonAfter={<span>원</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: "right", marginRight: 0 }}
            />
            <div className="subtext">할인</div>
            <Checkbox
              name="discount_maximum_condition"
              checked={selectedOptions.discount_maximum_condition}
              onChange={handleSelectOptions}
            >
              무제한
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="center-label"
          label="수량 한정"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <Row align="middle">
            <Input
              className="coupon-register-form-input-number"
              type="number"
              name="coupon_publish_number"
              value={formValues.coupon_publish_number}
              disabled={selectedOptions.quantity}
              min={0}
              addonAfter={<span>개</span>}
              onChange={handleInputChange}
              style={{ width: 150, textAlign: "right" }}
            />
            <Checkbox
              name="quantity"
              checked={selectedOptions.quantity}
              onChange={handleSelectOptions}
            >
              무제한
            </Checkbox>
          </Row>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          label="쿠폰 적용 대상"
          colon={false}
          labelAlign={"left"}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
          style={{ marginBottom: 0 }}
        >
          <Radio.Group
            name="coupon_type"
            onChange={handleSelectOptions}
            value={selectedOptions.coupon_type}
            disabled={match.params.hasOwnProperty("id")}
          >
            {couponTypeItems.map((couponType, idx) => {
              if (couponType.value === "product") {
                return (
                  <Radio key={`coupon_type_${idx}`} value={couponType.value}>
                    {couponType.label}
                  </Radio>
                );
              } else {
                return (
                  <Radio
                    key={`coupon_type_${idx}`}
                    value={couponType.value}
                    disabled={
                      selectedOptions.benefit_kind === "related_product" ||
                      (couponType.value === "total" &&
                        !(user && user.role && user.role === "super_admin"))
                    }
                  >
                    {couponType.label}
                  </Radio>
                );
              }
            })}
          </Radio.Group>
        </Form.Item>
        {selectedOptions.benefit_kind === "related_product" &&
        selectedOptions.coupon_type === "product" ? (
          <>
            <div
              className="coupon-target-border-wrap"
              style={{ borderBottom: 0, marginTop: 20 }}
            >
              <div className="coupon-target-title">연관 상품 조회</div>
            </div>
            <div
              className="coupon-target-border-wrap"
              style={{ padding: "20px 25px" }}
            >
              <Row align="middle">
                {selectedOptions.coupon_type !== "brand" && (
                  <Form.Item
                    className="center-label"
                    label="상품명"
                    colon={false}
                    labelAlign={"left"}
                    // labelCol={{ span: 3 }}
                    // wrapperCol={{ span: 21 }}
                    style={{ marginRight: 20 }}
                  >
                    <Input
                      name="product_name"
                      value={searchOptions.product_name}
                      onChange={handleInputChange}
                      style={{ width: 170 }}
                    />
                  </Form.Item>
                )}
                <Form.Item
                  className="center-label"
                  label="브랜드명"
                  colon={false}
                  labelAlign={"left"}
                  // labelCol={{ span: 3 }}
                  // wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_brand_name"
                    value={searchOptions.product_brand_name}
                    onChange={handleInputChange}
                    style={{ width: 170 }}
                  />
                </Form.Item>
              </Row>
              <Row align="middle">
                <Button className="search-button" onClick={onSearchProduct}>
                  검색
                </Button>
                <Button className="cancel-button" onClick={handleResetSearch}>
                  초기화
                </Button>
              </Row>
            </div>
            <div className="coupon-target-border-wrap content-padding">
              <div className="coupon-target-content-wrap">
                <div className="title2">
                  검색 상품{" "}
                  <span className="total-product-count">
                    {selectedOptions.coupon_type === "brand"
                      ? brandList?.length
                      : productList?.length}
                  </span>
                  개 / 선택 상품{" "}
                  <span className="select-product-count">
                    {selectedRows?.length}
                  </span>
                  개
                </div>
                <Button
                  className="product-select-button"
                  disabled={selectedRelatedProductRowKeys?.length === 0}
                  onClick={handleSelectedRowRegister}
                >
                  선택등록
                </Button>
              </div>
              <Row>
                <Col span={11}>
                  <Table
                    className="product-list-table"
                    rowSelection={{ ...rowSelection, type: "radio" }}
                    columns={relatedMainProductColumns}
                    dataSource={productList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey="id"
                    rowClassName="coupon-table-row"
                    tableLayout={"auto"}
                    scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                    onRow={handleRowEvent}
                    pagination={false}
                  />
                </Col>
                <Col span={2} className="col">
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/images/promotion/coupon-table-arrow.png`}
                    style={{ objectFit: "cover", width: "60%" }}
                  />
                </Col>
                <Col span={11}>
                  <Table
                    className="product-list-table"
                    rowSelection={selectedRelatedProductRowSelection}
                    columns={relatedProductColumns}
                    dataSource={relatedProductList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey="related_product_id"
                    rowClassName="coupon-table-row"
                    scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                    tableLayout={"auto"}
                    onRow={handleRelatedProductRowEvent}
                    pagination={false}
                  />
                </Col>
              </Row>
              <Divider className="product-register-form-input-divider" />
              <div className="coupon-target-content-wrap">
                <Row align="middle">
                  <div className="coupon-target-title" style={{ padding: 0 }}>
                    연관 상품 등록
                  </div>
                  <div className="coupon-target-subtitle">
                    총{" "}
                    <span className="total-product-count">
                      {selectedTargetList?.length}
                    </span>
                    개
                  </div>
                </Row>
                <Button
                  className="product-select-cancel-button"
                  disabled={selectedProductRows?.length === 0}
                  onClick={handleSelectedRowCancel}
                >
                  선택삭제
                </Button>
                <Table
                  className="product-list-table"
                  rowSelection={selectedRowSelection}
                  columns={mainAndRelatedProductColumns}
                  dataSource={selectedTargetList}
                  loading={isLoading}
                  bordered
                  size="middle"
                  rowKey="id"
                  rowClassName="coupon-table-row"
                  scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                  tableLayout={"auto"}
                  onRow={handleProductRowEvent}
                  pagination={false}
                />
              </div>
            </div>
          </>
        ) : (
          selectedOptions.coupon_type !== "total" && (
            <>
              <div
                className="coupon-target-border-wrap"
                style={{ borderBottom: 0, marginTop: 20 }}
              >
                <div className="coupon-target-title">
                  쿠폰 적용{" "}
                  {selectedOptions.coupon_type === "brand" ? "브랜드" : "상품"}{" "}
                  등록
                </div>
              </div>
              <div
                className="coupon-target-border-wrap"
                style={{ padding: "20px 25px" }}
              >
                <Row align="middle">
                  {selectedOptions.coupon_type !== "brand" && (
                    <Form.Item
                      className="center-label"
                      label="상품명"
                      colon={false}
                      labelAlign={"left"}
                      // labelCol={{ span: 3 }}
                      // wrapperCol={{ span: 21 }}
                      style={{ marginRight: 20 }}
                    >
                      <Input
                        name="product_name"
                        value={searchOptions.product_name}
                        onChange={handleInputChange}
                        style={{ width: 170 }}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    className="center-label"
                    label="브랜드명"
                    colon={false}
                    labelAlign={"left"}
                    // labelCol={{ span: 3 }}
                    // wrapperCol={{ span: 21 }}
                  >
                    <Input
                      name="product_brand_name"
                      value={searchOptions.product_brand_name}
                      onChange={handleInputChange}
                      style={{ width: 170 }}
                    />
                  </Form.Item>
                </Row>
                <Row align="middle">
                  <Button className="search-button" onClick={onSearchProduct}>
                    검색
                  </Button>
                  <Button className="cancel-button" onClick={handleResetSearch}>
                    초기화
                  </Button>
                </Row>
              </div>
              <div className="coupon-target-border-wrap content-padding">
                <div className="coupon-target-content-wrap">
                  <div className="title2">
                    검색{" "}
                    {selectedOptions.coupon_type === "brand"
                      ? "브랜드"
                      : "상품"}
                    <span className="total-product-count">
                      {selectedOptions.coupon_type === "brand"
                        ? brandList?.length
                        : productList?.length}
                    </span>
                    개 / 선택{" "}
                    {selectedOptions.coupon_type === "brand"
                      ? "브랜드"
                      : "상품"}{" "}
                    <span className="select-product-count">
                      {selectedRows?.length}
                    </span>
                    개
                  </div>
                  <Button
                    className="product-select-button"
                    disabled={selectedRows?.length === 0}
                    onClick={handleSelectedRowRegister}
                  >
                    선택등록
                  </Button>
                  {selectedOptions.coupon_type === "brand" ? (
                    <Table
                      className="product-list-table"
                      rowSelection={rowSelection}
                      columns={brandColumns}
                      dataSource={brandList}
                      loading={isLoading}
                      bordered
                      size="middle"
                      rowKey="id"
                      rowClassName="coupon-table-row"
                      scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                      tableLayout={"auto"}
                      onRow={handleRowEvent}
                      pagination={false}
                    />
                  ) : (
                    <Table
                      className="product-list-table"
                      rowSelection={rowSelection}
                      columns={productColumns}
                      dataSource={productList}
                      loading={isLoading}
                      bordered
                      size="middle"
                      rowKey="product_id"
                      rowClassName="coupon-table-row"
                      scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                      tableLayout={"auto"}
                      onRow={handleRowEvent}
                      pagination={false}
                    />
                  )}
                </div>
                <Divider className="product-register-form-input-divider" />
                <div className="coupon-target-content-wrap">
                  <Row align="middle">
                    <div className="coupon-target-title" style={{ padding: 0 }}>
                      쿠폰 적용{" "}
                      {selectedOptions.coupon_type === "brand"
                        ? "브랜드"
                        : "상품"}{" "}
                      등록
                    </div>
                    <div className="coupon-target-subtitle">
                      총{" "}
                      <span className="total-product-count">
                        {selectedTargetList?.length}
                      </span>
                      개
                    </div>
                  </Row>
                  <Button
                    className="product-select-cancel-button"
                    disabled={selectedProductRows?.length === 0}
                    onClick={handleSelectedRowCancel}
                  >
                    선택삭제
                  </Button>
                  <Table
                    className="product-list-table"
                    rowSelection={selectedRowSelection}
                    columns={
                      selectedOptions.coupon_type === "brand"
                        ? brandColumns
                        : productColumns
                    }
                    dataSource={selectedTargetList}
                    loading={isLoading}
                    bordered
                    size="middle"
                    rowKey={
                      selectedOptions.coupon_type === "brand" ||
                      selectedOptions.benefit_type === "related_product"
                        ? "id"
                        : "product_id"
                    }
                    rowClassName="coupon-table-row"
                    scroll={{ x: "max-content", y: "calc(220px - 48px)" }}
                    tableLayout={"auto"}
                    onRow={handleProductRowEvent}
                    pagination={false}
                  />
                </div>
              </div>
            </>
          )
        )}
      </div>
      <Row
        justify="center"
        align="middle"
        className="coupon-register-button-wrap"
      >
        <Button className="confirm" loading={isLoading} onClick={handleFinish}>
          확인
        </Button>
        <Button className="cancel" onClick={handleCancel}>
          취소
        </Button>
      </Row>
    </>
  );
};

export default CouponCreateComponent;
